import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './input.css';
import VueGtag from 'vue-gtag';

const app = createApp(App);

app.use(store)
   .use(router)
   .use(VueGtag, {
      config: { id: 'G-T61GMB89WC' }  // Replace with your GA4 ID
   });

app.mount('#app');